import React from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertFromRaw } from 'draft-js';
import { draftToMarkdown, markdownToDraft } from 'markdown-draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

class RichTextEditor extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['markdown', 'html']),
    text: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }
  constructor(props) {
    super(props);
    const { text, type } = this.props;
    let content;
    switch(type) {
      case 'html': {
        const { contentBlocks, entityMap } = htmlToDraft(text || '');
        content = ContentState.createFromBlockArray(contentBlocks, entityMap);
        break;
      }
      case 'markdown':
      default: {
        const rawContent = markdownToDraft(text || '');
        content = convertFromRaw(rawContent);
        break;
      }
    }

    this.state = {
      editorState: text ? EditorState.createWithContent(content) : EditorState.createEmpty()
    }

    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(value) {
    if(!this.props.onChange) {
      return console.warn('You must provide an RichTextEditor.onChange()');
    }
    switch(this.props.type) {
      case 'html': {
        this.props.onChange(draftToHtml(value));
        break;
      }
      case 'markdown': {
        this.props.onChange(draftToMarkdown(value));
        break;
      }
      default: {
        console.warn('RichTextEditor.handleChange(): You must provide a content type.', this.props.type);
        break;
      }
    }
  }
  render() {
    return (
      <Editor
        editorState={this.state.editorState}
        onEditorStateChange={editorState => this.setState({ editorState })}
        onContentStateChange={this.handleChange}
      />
    );
  }
}

export default RichTextEditor;



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/rich-text-editor.js